import React from 'react';
// Removed component initialization imports - will attempt in main.tsx
// import { defineCustomElements, applyPolyfills } from '@nordhealth/components/loader'; 
import '@nordhealth/css';
// Remove the incorrect deep import
// import '@nordhealth/css/lib/themes/base.css';
// Import our custom Nord theme overrides
import '../../styles/nord-theme.css';
// Potentially import ColorModeContext if needed for theme switching logic
// import { useColorMode } from '../../contexts/ColorModeContext';

// Removed the call to applyPolyfills/defineCustomElements from module scope

// Add a declaration for the Nord components
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'nord-avatar': any;
      'nord-button': any;
      'nord-card': any;
      'nord-icon': any;
      'nord-message': any;
      'nord-stack': any;
      'nord-tag': any;
      [elemName: string]: any;
    }
  }
}

interface NordProviderProps {
  children: React.ReactNode;
}

/**
 * Provider component for Nord UI setup.
 * Currently acts as a simple wrapper, but can be extended
 * for theme context or initialization logic if needed.
 */
const NordProvider: React.FC<NordProviderProps> = ({ children }) => {
  // Placeholder for potential Nord UI initialization or context
  // e.g., useEffect for setting theme based on context

  return <>{children}</>; // Render children directly for now
};

export default NordProvider; 